import React from "react";

export default function ExploreGraphic(props) {
  return (
    <svg
      width={808}
      height={445}
      viewBox="0 0 808 445"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M710.97 343.123h-3.075c.326-1.287.514-2.633.514-4.029 0-8.562-6.509-15.5-14.538-15.5-2.92 0-5.63.925-7.909 2.503-2.082-14.63-12.139-25.729-24.239-25.729-12.942 0-23.548 12.7-24.555 28.837-1.55-1.004-3.283-1.582-5.123-1.582-6.458 0-11.694 6.94-11.694 15.5h-4.912c-8.053 0-14.641 7.171-14.641 15.936v1.171c0 8.765 6.588 15.936 14.641 15.936h95.53c8.053 0 14.642-7.17 14.642-15.936v-1.17c0-8.766-6.588-15.937-14.641-15.937M193.872 308.174h-4.285c.392-1.807.606-3.706.606-5.669 0-11.897-7.704-21.542-17.208-21.542-1.418 0-2.794.22-4.112.624-3.987-9.185-11.762-15.42-20.7-15.42-9.964 0-18.476 7.751-21.913 18.697a17.843 17.843 0 0 0-1.487-.067c-10.031 0-18.163 8.348-18.163 18.645 0 1.491.176 2.938.498 4.33-1.24.017-2.438.16-3.585.403-1.568.001-3.034.562-4.29 1.517-3.992 2.08-5.06 5.64-5.06 9.685 0 6.416 5.144 9.656 21.44 9.656h78.259c4.582 0 8.33-4.693 8.33-10.429 0-5.737-3.748-10.43-8.33-10.43M576.872 187.174h-4.285c.392-1.807.606-3.706.606-5.669 0-11.897-7.704-21.542-17.208-21.542-1.418 0-2.794.22-4.112.624-3.987-9.185-11.762-15.42-20.7-15.42-9.964 0-18.476 7.751-21.913 18.697a17.843 17.843 0 0 0-1.487-.067c-10.031 0-18.163 8.348-18.163 18.645 0 1.491.176 2.938.498 4.33-1.24.017-2.438.16-3.585.403-1.568.001-3.034.562-4.29 1.517-3.992 2.08-5.06 5.64-5.06 9.685 0 6.416 5.144 9.656 21.44 9.656h78.259c4.582 0 8.33-4.693 8.33-10.429 0-5.737-3.748-10.43-8.33-10.43"
          fill="#ECECEC"
        />
        <path
          fill="#86E0C2"
          d="M91.181 159.3l4.695 5.361 7.6-.703-4.251 5.978 2.793 6.432-7.322-1.668-5.874 4.68-.273-7.009-6.425-3.542 7.154-2.663zM723.264 229.343l3.347 3.823 5.42-.5-3.032 4.261 1.991 4.587-5.22-1.19-4.188 3.336-.196-4.997-4.58-2.524 5.101-1.9zM584.011 384.095l.02 7.297 6.341 4.568-7.303 1.757-2.168 6.846-4.534-6.21-7.681-.339 4.501-5.596-2.578-7.054 7.313 2.753z"
        />
        <path
          fill="#75CFEC"
          d="M343.63 183.888l4.975 5.683 8.055-.745-4.507 6.335 2.96 6.819-7.76-1.768-6.225 4.958-.29-7.428-6.81-3.752 7.583-2.824zM127.527 366.272l1.54 8.604 8.431 4.07-8.25 3.59-1.135 8.527-6.639-6.385-9.132 1.199 4.147-7.536-4.509-7.786 9.201 1.728z"
        />
        <path
          fill="#FEC391"
          d="M561.86 92.159l4.536 6.09 7.484-.313-4.269 6.23 2.652 7.14-7.175-2.24-5.844 4.727-.166-7.615-6.264-4.22 7.072-2.466zM719.234 293.504l-4.986 5.776 1.936 7.273-7.04-2.83-6.427 4.155.636-7.525-5.909-4.703 7.434-1.82 2.774-7.064 3.96 6.4z"
        />
        <path
          d="M600.806 15v16.333M607.611 23.166h-13.61M343.805 1v16.333M350.611 9.166h-13.61M518.806 300v16.333M525.611 308.166h-13.61M799.806 262v16.333M806.611 270.166h-13.61M206.805 78v16.333M213.611 86.166h-13.61M297.611 342.833v16.333M304.417 351h-13.611M7.806 296.333v16.333M14.611 304.5H1.001"
          stroke="#DADADA"
          strokeWidth={2}
          strokeLinecap="round"
        />
        <path
          d="M98.45 239.657c1.604-5.085.409-10.864-3.602-14.917-5.766-5.826-15.165-5.875-20.991-.108a14.77 14.77 0 0 0-4.139 7.777 14.908 14.908 0 0 0-.213 3.949 14.775 14.775 0 0 0 4.244 9.264c5.766 5.827 15.164 5.875 20.99.109.224-.221.436-.45.643-.68a14.765 14.765 0 0 0 3.068-5.394"
          fill="#FEDBBD"
        />
        <path
          d="M678.742 176.431c-.787-6.574-5.095-12.504-11.707-15.038-9.507-3.645-20.167 1.108-23.812 10.615a18.349 18.349 0 0 0-.705 10.919 18.472 18.472 0 0 0 1.78 4.579 18.348 18.348 0 0 0 9.541 8.313c9.507 3.644 20.168-1.109 23.811-10.616.14-.364.263-.731.378-1.098.8-2.55 1.015-5.159.714-7.674"
          fill="#B0E3F4"
        />
        <path
          d="M710.193 170.96c-.858-5.339-21.722-3.964-34.08-2.669l-.99.105 1.335 2.523.452-.048c23.071-2.42 29.061-.39 29.34.51.002.022.04 2.292-11.176 5.818-8.887 2.792-20.887 5.474-33.787 7.55-12.902 2.074-25.137 3.291-34.449 3.426-11.253.181-11.894-1.82-11.929-2.045-.006-.037.796-3.94 27.483-9.739l.446-.096.467-2.79-.97.21c-12.249 2.661-32.67 7.925-31.81 13.276.43 2.668 4.92 3.86 14.56 3.86.577 0 1.174-.007 1.791-.015 9.444-.137 21.815-1.366 34.834-3.46 13.024-2.096 25.156-4.809 34.164-7.64 10.354-3.255 14.77-5.962 14.32-8.777"
          fill="#86E0C2"
        />
        <path
          d="M99.287 232.607l-1.065-.352.174 2.759.486.16c17.01 5.639 21.077 9.068 21.222 9.827-.008.015-.887 1.505-9.9.42-7.438-.895-17.12-2.906-27.262-5.66-10.146-2.753-19.515-5.914-26.383-8.901-8.07-3.51-7.96-5.153-7.973-5.153.042-.043 2.536-2.331 23.163 2.076l.5.106 1.528-2.278-1.094-.233c-22.004-4.701-27.371-2.95-27.995-.654-.604 2.223 2.333 4.662 9.522 7.912.428.193.867.388 1.322.586 6.986 3.036 16.482 6.242 26.735 9.024 10.26 2.786 20.072 4.82 27.63 5.73 2.894.35 5.279.529 7.202.529 4.008 0 6.014-.772 6.449-2.376.623-2.294-3.08-6.501-24.261-13.522"
          fill="#B0E3F4"
        />
        <g>
          <path
            d="M556.89 429.5h-20.645a1.135 1.135 0 0 1-1.134-1.135v-1.699c0-.627.508-1.135 1.134-1.135h17.6l-3.502-4.563h-20.932a1.136 1.136 0 0 1-1.134-1.135v-1.698c0-.627.51-1.135 1.134-1.135h17.886l-13.686-17.834-35.059 45.682h70.117L556.89 429.5z"
            fill="#C0EADB"
          />
          <path
            d="M528.277 418.135v1.698c0 .626.51 1.135 1.135 1.135h20.931L547.298 417h-17.886c-.626 0-1.135.508-1.135 1.135M535.111 426.666v1.7c0 .625.508 1.134 1.135 1.134h20.644l-3.045-3.969h-17.599c-.627 0-1.135.508-1.135 1.135"
            fill="#86E0C2"
          />
          <path
            d="M245.527 347.237h-83.592a3.862 3.862 0 0 1-3.862-3.861V239.568a3.861 3.861 0 0 1 3.862-3.861h83.592a3.86 3.86 0 0 1 3.861 3.86v103.809a3.86 3.86 0 0 1-3.86 3.86"
            fill="#FE9840"
          />
          <path
            d="M229.382 319.698H178.08a3.86 3.86 0 0 1-3.861-3.861V298.36a3.86 3.86 0 0 1 3.86-3.861h51.303a3.86 3.86 0 0 1 3.86 3.86v17.478a3.86 3.86 0 0 1-3.86 3.86M229.382 275.185H178.08a3.86 3.86 0 0 0-3.861 3.86v1.247a3.861 3.861 0 0 0 3.86 3.862h51.303a3.861 3.861 0 0 0 3.86-3.862v-1.246a3.86 3.86 0 0 0-3.86-3.861"
            fill="#FEC391"
          />
          <path
            d="M523.625 237.4h-73.016a4.004 4.004 0 0 1-4.004-4.003v-98.84a4.004 4.004 0 0 1 4.004-4.003h73.016a4.004 4.004 0 0 1 4.004 4.004v98.839a4.004 4.004 0 0 1-4.004 4.003"
            fill="#23C991"
          />
          <path
            d="M508.06 216.886h-41.886a4.004 4.004 0 0 1-4.003-4.004v-61.287a4.003 4.003 0 0 1 4.003-4.004h41.885a4.003 4.003 0 0 1 4.003 4.004v61.287a4.004 4.004 0 0 1-4.003 4.004"
            fill="#86E0C2"
          />
          <path
            d="M306.379 294.184h-85.393a3.861 3.861 0 0 1-3.861-3.861V163.028a3.862 3.862 0 0 1 3.86-3.862h85.394a3.861 3.861 0 0 1 3.86 3.862v127.295a3.86 3.86 0 0 1-3.86 3.86"
            fill="#00A7DB"
          />
          <path
            d="M293.88 266.25h-60.395a3.862 3.862 0 0 1-3.861-3.863v-82.414a3.862 3.862 0 0 1 3.86-3.862h60.396a3.861 3.861 0 0 1 3.86 3.862v82.414a3.861 3.861 0 0 1-3.86 3.862"
            fill="#75CFEC"
          />
          <path
            d="M644.128 355.423h-82.675a3.842 3.842 0 0 1-3.842-3.842V230.6a3.842 3.842 0 0 1 3.842-3.84h82.675a3.841 3.841 0 0 1 3.84 3.84v120.982a3.842 3.842 0 0 1-3.84 3.842"
            fill="#00A7DB"
          />
          <path
            d="M631.112 337.065h-56.645a3.84 3.84 0 0 1-3.84-3.841V280.6a3.84 3.84 0 0 1 3.84-3.841h56.645a3.841 3.841 0 0 1 3.841 3.84v52.625a3.841 3.841 0 0 1-3.84 3.84M631.112 265.28h-56.645a3.84 3.84 0 0 1-3.84-3.841v-.126a3.84 3.84 0 0 1 3.84-3.841h56.645a3.841 3.841 0 0 1 3.841 3.84v.127a3.842 3.842 0 0 1-3.84 3.842"
            fill="#75CFEC"
          />
          <path
            d="M471.152 194.273h-81.865a4.003 4.003 0 0 1-4.003-4.003V71.17a4.003 4.003 0 0 1 4.003-4.003h81.865a4.004 4.004 0 0 1 4.004 4.003v119.1a4.004 4.004 0 0 1-4.004 4.003"
            fill="#FE9840"
          />
          <path
            d="M456.812 154.245h-53.186a4.003 4.003 0 0 1-4.003-4.003v-65.88a4.004 4.004 0 0 1 4.003-4.003h53.186a4.004 4.004 0 0 1 4.004 4.004v65.879a4.003 4.003 0 0 1-4.004 4.003M456.812 166.018h-53.186a4.003 4.003 0 0 0-4.003 4.003v1.292a4.004 4.004 0 0 0 4.003 4.004h53.186a4.004 4.004 0 0 0 4.004-4.004v-1.292a4.003 4.003 0 0 0-4.004-4.003"
            fill="#FEC391"
          />
          <path
            d="M428.545 404.166H346.8a4.357 4.357 0 0 1-4.357-4.356V277.522a4.357 4.357 0 0 1 4.357-4.356h81.745a4.356 4.356 0 0 1 4.356 4.356V399.81a4.356 4.356 0 0 1-4.356 4.356"
            fill="#23C991"
          />
          <path
            d="M411.166 346.343h-46.987a4.357 4.357 0 0 1-4.358-4.356v-47.934a4.357 4.357 0 0 1 4.358-4.356h46.987a4.357 4.357 0 0 1 4.357 4.356v47.934a4.357 4.357 0 0 1-4.357 4.356M411.276 390.872h-47.208a4.246 4.246 0 1 1 0-8.494h47.208a4.246 4.246 0 1 1 0 8.494M411.166 376.178h-46.987a4.357 4.357 0 0 1-4.358-4.356v-6.848a4.358 4.358 0 0 1 4.358-4.357h46.987a4.357 4.357 0 0 1 4.357 4.357v6.848a4.357 4.357 0 0 1-4.357 4.356"
            fill="#86E0C2"
          />
          <path
            d="M514.33 427.5h-28.084a1.135 1.135 0 0 1-1.135-1.135v-1.699c0-.627.508-1.135 1.135-1.135h25.038l-5.037-6.563h-26.835a1.136 1.136 0 0 1-1.135-1.135v-1.698c0-.627.509-1.135 1.135-1.135H503.2l-19.59-25.527-44.032 57.375h88.064L514.33 427.5z"
            fill="#B0E3F4"
          />
          <path
            d="M478.277 414.135v1.698c0 .626.51 1.135 1.135 1.135h26.835L503.201 413h-23.789c-.626 0-1.135.508-1.135 1.135M485.111 424.666v1.7c0 .625.508 1.134 1.135 1.134h28.084l-3.046-3.969h-25.038c-.627 0-1.135.508-1.135 1.135"
            fill="#75CFEC"
          />
          <path
            d="M308.605 430.733h-22.85a.922.922 0 0 1-.923-.923v-1.382c0-.51.413-.924.922-.924h20.372l-4.098-5.34h-21.833a.924.924 0 0 1-.924-.923v-1.382c0-.51.414-.924.924-.924h19.355l-15.939-20.768-35.826 46.68h71.652l-10.832-14.114z"
            fill="#B0E3F4"
          />
          <path
            d="M279.271 419.859v1.382c0 .51.414.924.924.924h21.833l-2.478-3.23h-19.355a.924.924 0 0 0-.924.924M284.832 428.428v1.382c0 .51.413.923.923.923h22.85l-2.478-3.229h-20.372a.923.923 0 0 0-.923.924"
            fill="#75CFEC"
          />
          <path
            d="M245.7 112.166a4.09 4.09 0 1 1-8.179 0 4.09 4.09 0 0 1 8.179 0M605.7 76.166a4.09 4.09 0 1 1-8.179 0 4.09 4.09 0 0 1 8.179 0"
            fill="#86E0C2"
          />
          <path
            d="M49.28 281.5a4.003 4.003 0 1 1-8.005 0 4.003 4.003 0 0 1 8.005 0M747.614 288.166a4.003 4.003 0 1 1-8.005 0 4.003 4.003 0 0 1 8.005 0M553.616 44.166a4.003 4.003 0 1 1-8.005.001 4.003 4.003 0 0 1 8.005 0"
            fill="#75CFEC"
          />
          <path
            d="M37.278 325.5a3.533 3.533 0 1 1-7.066-.001 3.533 3.533 0 0 1 7.066 0"
            fill="#FEC391"
          />
          <path
            d="M165.278 401.5a3.533 3.533 0 1 1-7.066-.001 3.533 3.533 0 0 1 7.066 0"
            fill="#86E0C2"
          />
          <path
            d="M369.798 227.166a3.187 3.187 0 1 1-6.375 0 3.187 3.187 0 0 1 6.375 0M498.798 331.166a3.187 3.187 0 1 1-6.375 0 3.187 3.187 0 0 1 6.375 0"
            fill="#FEC391"
          />
        </g>
      </g>
    </svg>
  );
}
